module.exports = __webpack_public_path__ + "static/media/Slice18@2x.c3182a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice18@2x.png
// module id = 1447
// module chunks = 0